import { checkEligibility } from "../api/GetStartScrubEligibility";

export const ScrubEligibilityReducer = (state, action) => {
    switch(action.type) {
        case "CHECK_ELIGIBILITY":
            const {scrubType, dispatcher} = action.data;
            checkEligibility({scrubType}, dispatcher);
            return {...state, dispatchCheckStatus: "loading"};
        case "SET_ELIGIBILITY":
            return {...state, dispatchCheckStatus: "success", eligibilityStatus: action.data.eligibilityStatus,
            metaData: action.data.metaData};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/ScrubEligibilityReducer.js